import {
  MultiSelectionFilterWrapper,
  MultiSelectionItemsWrapper,
} from './MultiSelectionFilterStyle';
import { ListingFilterItemInterface, MultiSelectionFilterProps } from './types';
import MultiSelectionItem from './MultiSelectionFilterItem';

const MultiSelectionFilter = ({
  data,
  handleSelectedItems,
  selectedItems,
  singleItemClassName,
  subTitleKey = 'subTitle',
}: MultiSelectionFilterProps) => {
  return (
    <MultiSelectionFilterWrapper>
      <MultiSelectionItemsWrapper>
        {data?.map((item: ListingFilterItemInterface) => (
          <MultiSelectionItem
            key={item.key?.toString()}
            item={item}
            value={selectedItems.includes(item.key)}
            onChange={(selected) => {
              item.selected = selected;
              if (selected) {
                handleSelectedItems([...selectedItems, item.key]);
              } else {
                handleSelectedItems(
                  selectedItems.filter((sKey) => sKey !== item.key)
                );
              }
            }}
            subTitleKey={subTitleKey}
            singleItemClassName={singleItemClassName}
          />
        ))}
      </MultiSelectionItemsWrapper>
    </MultiSelectionFilterWrapper>
  );
};

export default MultiSelectionFilter;
